import createReducer from './baseReducer';

export default createReducer('accounts', 'account');
